export enum WriterTypes {
	CSV = 0,
	XML = 1,
	JSON = 2,
}
